import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  contactsHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(2, 2, 1.5, 2),
  },
}));

const MainHeader = ({ children }) => {
  const { classes } = useStyles();

  return <div className={classes.contactsHeader}>{children}</div>;
};

export default MainHeader;
